export default "__VITE_ASSET__BHI$ZMS6__"